import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'

import compose from '@shopify/react-compose'

import { withEndUser, withConfiguration, withPreview } from '@portal/kit/pkg/components'

import Login                from 'components/login'
import Support              from 'components/support'
import PasswordRecovery     from 'components/login/password-recovery'
import RecoverySetPassword  from 'components/login/update-password'

import Dashboard        from 'components/dashboard'
import Account          from 'components/account'
import EditEmail        from 'components/account/edit-email'
import EditPassword     from 'components/account/edit-password'
import NotFound         from 'components/not-found'
import EditPhoneNumber  from 'components/account/edit-phone-number'
import Subscriptions    from 'components/account/subscriptions'
import EditName         from 'components/account/edit-name'
import Ran              from 'components/ran'

import { isRanEligible, hasOffers, hasRan } from 'helpers/ran'
import { withRan } from 'components/providers/ran'
import OfferRoutes from 'components/offers/routes'

const publicRoutes = {
  '/login':                           () => <Login />,
  '/support':                         () => <Support />,
  '/login/password-recovery':         () => <PasswordRecovery />,
  '/login/password-recovery/:token':  () => <RecoverySetPassword />,
}

const authenticatedRoutes = {
  '/':                              () => <Dashboard />,
  '/my-account':                    () => <Account />,
  '/my-account/email':              () => <EditEmail />,
  '/my-account/name':               () => <EditName />,
  '/my-account/password':           () => <EditPassword />,
  '/my-account/phone-number':       () => <EditPhoneNumber />,
  '/my-account/subscriptions':      () => <Subscriptions />,
}

const ranRoutes = {
  '/ran':                           () => <Ran />
}

const authenticatedComponent = (component, props) => {
  return props.user.isLoggedIn() ? component() : publicRoutes['/login']()
}

const Routes = props =>
  <Switch>
    {Object.keys(publicRoutes).map(path =>
      <Route exact path={path} key={path} render={() => publicRoutes[path]()} />
    )}
    {Object.keys(authenticatedRoutes).map(path =>
      <Route exact path={path} key={path} render={() => authenticatedComponent(authenticatedRoutes[path], props)} />
    )}

    {(isRanEligible(props) || hasRan(props)) && Object.keys(ranRoutes).map(path =>
      <Route exact path={path} key={path} render={() => authenticatedComponent(ranRoutes[path], props)} />
    )}

    { hasOffers(props) && <OfferRoutes userLogged={props.user.isLoggedIn()}/> }
    <Route component={NotFound} />
  </Switch>

// these are the props passed to all views
Routes.propTypes = {
  user: PropTypes.object.isRequired,
  portalConfiguration: PropTypes.object.isRequired,
}

export default compose(
  withEndUser,
  withConfiguration,
  withPreview,
  withRan
)(Routes)
